import { render, staticRenderFns } from "./AccessRuleTable.vue?vue&type=template&id=1c268b0d&"
import script from "./AccessRuleTable.vue?vue&type=script&lang=js&"
export * from "./AccessRuleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports